import React, { useEffect, useState, useRef } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import APICom from '../utils/helpers/APICom';
import ConfirmationModal from '../components/Controls/ConfirmationModal';

const TripFilterInterface = () => {
  const [AffiliateID, setAffiliateID] = useState(-1)

  const xCancelSourceForGrid = useRef(null);
  const [attributeTypes, setAttributeTypes] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [iterations, setIterations] = useState({});
  const [currentIteration, setCurrentIteration] = useState("");
  const [formData, setFormData] = useState({
    attributeType: '',
    attribute: '',
    matchExempted: false,
    only: false
  });
  const [obj, setObj] = useState(null)
  const [confirmationModalObj, setConfirmationModalObj] = useState({
    show: false, title: 'Confirmation',
    body: 'Are you Sure you want to Delete Rule?', btnCanceText: 'No',
    btnOkText: 'Yes', closeOnly: false, isCancel: false
  });
  const [confirmationModalObj1, setConfirmationModalObj1] = useState({
    show: false, title: 'Confirmation',
    body: 'Are you Sure you want to Delete Rule?', btnCanceText: 'No',
    btnOkText: 'Yes',
  });
  const [editingRule, setEditingRule] = useState(null);
  const [reload, setReload] = useState(true)

  const handleConfirmationModalOk = async () => {
    if (obj?.onlyIterationId) {
      setIterations(prev => {
        const newIterations = { ...prev };
        delete newIterations[obj.iterationId];
        return newIterations;
      });

      const payload = {
        iAffiliateID: AffiliateID,
        iIterationID: obj.iterationId
      };
      xCancelSourceForGrid.current = APICom.GenerateSource();
      await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/DeleteAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);
      setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
      setObj(null)
      return
    }
    setIterations(prev => {
      const updatedRules = prev[obj?.iterationId]?.rules?.filter(rule => rule?.id !== obj?.ruleId);
      return {
        ...prev,
        [obj?.iterationId]: { ...prev[obj?.iterationId], rules: updatedRules }
      };
    });

    const payload = {
      iAffiliateID: AffiliateID,
      iID: obj?.ruleId
    };
    xCancelSourceForGrid.current = APICom.GenerateSource();
    let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/DeleteAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);
    setReload(!reload)
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setObj(null)
  }
  const handleConfirmationModalClose = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
  }
  const handleConfirmationModalCancel = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
  }
  const transformRuleData = (rule, attributeTypes, attributes) => {
    if (!rule?.iAttributeTypeID || !rule?.iAttributeID) {
      return {
        id: rule?.iID,
        attributeType: 'None',
        attribute: 'None',
        only: rule?.bAttributeOnly || false,
        matchExempted: rule?.bApplyAttribute || false,
      };
    }

    const attributeType = attributeTypes?.find(type => type?.iID === rule?.iAttributeTypeID);
    const attribute = attributes?.find(attr => attr?.iID === rule?.iAttributeID);

    return {
      id: rule?.iID,
      attributeType: attributeType?.vName || 'None',
      attribute: attribute?.vTitle || 'None',
      only: rule?.bAttributeOnly || false,
      matchExempted: rule?.bApplyAttribute || false,
    };
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = Number(params.get('id'))
    setAffiliateID(id)
    const fetchData = async () => {
      const payload = {
        iAffiliateID: id,
        iSettingID: 120
      };
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);

      if (response?.data) {
        setAttributeTypes(response?.data?.AttributeTypeData);
        setAttributes(response?.data?.AttributeData);

        const transformedIterations = {};
        response?.data?.RulesData?.forEach(rule => {
          if (!transformedIterations[rule?.iIteration]) {
            transformedIterations[rule?.iIteration] = {
              rules: [],
              routeType: rule?.vRouteFilter
            };
          }

          const transformedRule = transformRuleData(rule, response?.data?.AttributeTypeData, response?.data?.AttributeData);
          transformedIterations[rule?.iIteration]?.rules.push(transformedRule);
        });

        setIterations(transformedIterations);
      }
    };

    fetchData();
  }, [reload]);

  const getFilteredAttributes = (selectedAttributeType) => {
    if (!selectedAttributeType) return [];
    const typeId = attributeTypes.find(type => type?.vName === selectedAttributeType)?.iID;
    return attributes.filter(attr => attr?.iAttrType === typeId);
  };

  const iterationOptions = Object.keys(iterations).map(num => Number(num));

  const resetForm = () => {
    setFormData({
      attributeType: '',
      attribute: '',
      matchExempted: false,
      only: false
    });
    setEditingRule(null);
  };

  const handleAttributeTypeChange = (e) => {
    const newAttributeType = e.target.value;
    setFormData({
      ...formData,
      attributeType: newAttributeType,
      attribute: ''
    });
  };

  const handleAdd = async () => {
    if (!formData?.attributeType) {
      setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Validation", body: "Select Attribute Type", btnOkText: "OK"}));
      return
    }
    const attributeTypeId = attributeTypes?.find(type => type?.vName === formData?.attributeType)?.iID;
    const attributeId = attributes?.find(attr => attr?.vTitle === formData?.attribute)?.iID;

    let newIterationId = currentIteration;
    if (currentIteration === "") {
      newIterationId = Math.max(...Object.keys(iterations).map(Number), 0) + 1;
    }
    let payload = {
      iAffiliateID: AffiliateID,
      iIterationID: newIterationId,
      iAttributeID: attributeId || -1,
      iAttributeTypeID: attributeTypeId || -1,
      bOnly: formData?.only,
      bExempt: formData?.matchExempted,
    };

    if (editingRule) {
      payload = {
        ...payload,
        iID: editingRule.id
      }
    }

    try {
      xCancelSourceForGrid.current = APICom.GenerateSource();
      const response = await APICom.fetchData(
        "GenericManifestDotNetCoreURL",
        "api/Routing/UpdateAttributeSettings",
        "post",
        {},
        payload,
        xCancelSourceForGrid.current
      );

      if (response.data) {
        setIterations(prev => {
          const updatedIterations = { ...prev };
          const currentIterationData = prev[newIterationId] || { rules: [], routeType: 'All' };

          const newRule = {
            id: response?.data?.iID || Math.random(),
            attributeType: formData?.attributeType || 'None',
            attribute: formData?.attribute || 'None',
            only: formData?.only,
            matchExempted: formData?.matchExempted,
          };

          updatedIterations[newIterationId] = {
            ...currentIterationData,
            rules: [...currentIterationData?.rules, newRule],
          };

          return updatedIterations;
        });

        setCurrentIteration(newIterationId?.toString());
        setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Success", body: editingRule ? "Rule updated successfully!" : "Rule added successfully!", btnOkText: "OK" }));
        setReload(!reload)
      }
    } catch (error) {
      console.error('Error adding rule:', error);
    }

    resetForm();
  };

  const handleEdit = (iterationId, rule) => {
    setCurrentIteration(iterationId);
    setEditingRule(rule);
    setFormData({
      attributeType: rule?.attributeType,
      attribute: rule?.attribute,
      matchExempted: rule?.matchExempted,
      only: rule?.only
    });
  };

  const handleDeleteRule = async (iterationId, ruleId) => {
    setObj({ iterationId, ruleId })
    setConfirmationModalObj((prevState) => ({
      ...prevState, show: true, body: "Are you Sure you want to Delete Rule?", btnOkText: 'Yes'
    }));
  };

  const handleDeleteIteration = async (iterationId) => {
    setObj({ iterationId, onlyIterationId: true })
    setConfirmationModalObj((prevState) => ({
      ...prevState, show: true, body: "Are you Sure you want to Delete Iteration?", btnOkText: 'Yes' }));
  };

  const handleIterationChange = (e) => {
    const newIteration = e.target.value;
    setCurrentIteration(newIteration);
    if (newIteration === "") return;

    setIterations(prev => ({
      ...prev,
      [newIteration]: prev[newIteration] || { rules: [], routeType: 'All' }
    }));
  };

  const handleRouteTypeChange = async (iterationId, routeType) => {
    setIterations(prev => ({
      ...prev,
      [iterationId]: { ...prev[iterationId], routeType }
    }));

    const payload = {
      iAffiliateID: AffiliateID,
      iIterationID: iterationId,
      vRouteFilter: routeType
    };
    xCancelSourceForGrid.current = APICom.GenerateSource();
    await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UpdateRouteFilter", "post", {}, payload, xCancelSourceForGrid.current);
  };

  return (
    <div className="p-4">
      <Card style={{ width: "60%" }} className="mb-4">
        <Card.Body>
          <Form>
            <div className="d-flex align-items-center mb-3">
              <Form.Group className="me-3 d-flex align-items-center">
                <Form.Label className="me-2">Iteration</Form.Label>
                <Form.Select
                  className="w-auto"
                  value={currentIteration}
                  onChange={handleIterationChange}
                >
                  <option value="">Select Iteration</option>
                  {iterationOptions.map(num => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            <div className="mb-3">
              <span style={{ background: "#32728b", color: "white" }} className="border w-80 d-block mx-auto text-center p-2">
                Trip Filter Criteria
              </span>
              <Card.Body>
                <div className="d-flex gap-3 mb-3 align-items-center">
                  <Form.Group>
                    <Form.Label>Attribute Type</Form.Label>
                    <Form.Select
                      value={formData.attributeType}
                      onChange={handleAttributeTypeChange}
                    >
                      <option value="">Select Type</option>
                      {attributeTypes.map(type => (
                        <option key={type.iID} value={type.vName}>{type.vDesc}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Attribute</Form.Label>
                    <Form.Select
                      value={formData.attribute}
                      onChange={(e) => setFormData({ ...formData, attribute: e.target.value })}
                      disabled={!formData.attributeType}
                    >
                      <option value="">Select Attribute</option>
                      {getFilteredAttributes(formData.attributeType).map(attr => (
                        <option key={attr.iID} value={attr.vTitle}>{attr.vTitle}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mt-4">
                    <Form.Check
                      type="checkbox"
                      label="Match Exempted"
                      checked={formData.matchExempted}
                      onChange={(e) => setFormData({ ...formData, matchExempted: e.target.checked })}
                    />
                  </Form.Group>
                  <Form.Group className="mt-4">
                    <Form.Check
                      type="checkbox"
                      label="Exclusive"
                      checked={formData.only}
                      onChange={(e) => setFormData({ ...formData, only: e.target.checked })}
                    />
                  </Form.Group>
                </div>
                <Button
                  variant="primary"
                  onClick={handleAdd}
                >
                  {editingRule ? 'Update Rule' : 'Add Rule'}
                </Button>
              </Card.Body>
            </div>

            <div className="mb-3">
              <div style={{ background: "#32728b", color: "white", fontSize: "12px" }} className="row border p-2">
                <div className="col-1 border-end">Iteration</div>
                <div className="col-1 border-end">Trip Filter</div>
                <div className="col-2 border-end">Attribute Type</div>
                <div className="col-2 border-end">Attribute</div>
                <div className="col-1 border-end">Only</div>
                <div className="col-2 border-end">Match Exempted</div>
                <div className="col-2 border-end">Route Type</div>
                <div className="col-1">Actions</div>
              </div>
            </div>

            {Object?.entries(iterations)?.map(([iterationId, iteration]) => (
              <div key={iterationId} className="mb-4">
                <div style={{ background: "lightgrey" }} className="row border p-1 d-flex justify-content-center align-items-center">
                  <div className="col-1">{iterationId}</div>
                  <div className="col-1"></div>
                  <div className="col-2"></div>
                  <div className="col-2"></div>
                  <div className="col-1"></div>
                  <div className="col-2"></div>
                  <div className="col-2">
                    <Form.Select
                      value={iteration.routeType}
                      onChange={(e) => handleRouteTypeChange(Number(iterationId), e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="OnlyNew">Only New</option>
                    </Form.Select>
                  </div>
                  <div className="col-1">
                    <Button
                      variant="link"
                      className="p-0 text-danger"
                      onClick={() => handleDeleteIteration(Number(iterationId))}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                  </div>
                </div>

                {iteration.rules.map((rule, index) => (
                  <div key={`${iterationId}-${rule.id}`} className="row border p-2">
                    <div className="col-1">
                      <div className="d-flex gap-2">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => handleEdit(Number(iterationId), rule)}
                        >
                          <FontAwesomeIcon icon={faPencilAlt} />
                        </Button>
                        <Button
                          variant="link"
                          className="p-0 text-danger"
                          onClick={() => handleDeleteRule(Number(iterationId), rule.id)}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                      </div>
                    </div>
                    <div className="col-1">{index + 1}</div>
                    <div className="col-2">{rule.attributeType}</div>
                    <div className="col-2">{rule.attribute}</div>
                    <div className="col-1">
                      <Form.Check
                        type="checkbox"
                        checked={rule.only}
                        readOnly
                      />
                    </div>
                    <div className="col-2">
                      <Form.Check
                        type="checkbox"
                        checked={rule.matchExempted}
                        readOnly
                      />
                    </div>
                    <div className="col-2"></div>
                    <div className="col-1"></div>
                  </div>
                ))}
              </div>
            ))}

            <div className="d-flex justify-content-end mt-3">
              {/* <Button
                variant="primary"
                onClick={() => {
                  // Handle final save
                  window.close();
                }}
              >
                Save & Close
              </Button> */}
            </div>
          </Form>
        </Card.Body>
      </Card>

      <ConfirmationModal
        centered
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        show={confirmationModalObj.show}
        Title={confirmationModalObj.title}
        Body={confirmationModalObj.body}
        onOk={handleConfirmationModalOk}
        onCancel={handleConfirmationModalCancel}
        onClose={handleConfirmationModalClose}
        btnCanceText={confirmationModalObj.btnCanceText}
        btnOkText={confirmationModalObj.btnOkText}
        ShowCancelButton={"true"}
      />
      <ConfirmationModal
        centered
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        show={confirmationModalObj1.show}
        Title={confirmationModalObj1.title}
        Body={confirmationModalObj1.body}
        onOk={handleConfirmationModalClose}
        onCancel={handleConfirmationModalCancel}
        onClose={handleConfirmationModalClose}
        btnCanceText={confirmationModalObj1.btnCanceText}
        btnOkText={confirmationModalObj1.btnOkText}
        ShowCancelButton={"false"}
      />
    </div>
  );
};

export default TripFilterInterface;